define('core/WindowBus',[
    'jquery',
    'underscore',
    'backbone',
    'modernizr',
], function (
    $,
    _,
    Backbone,
    Modernizr
) {
    'use strict';

    /**
     * WindowBus: A cross-frame / tab message passing bus.
     *
     * WindowBus passes messages using localStorage,
     * which means messages are secure, though they persist
     * after the browser session closes.
     *
     * Messages may only be passed between the same domains.
     */
    var WindowBus = Backbone.Model.extend({
        initialize: function () {
            if (Modernizr.localstorage)
                $(window).on('storage', _.bind(this.onStorageEvent, this));
        },

        broadcast: function (name, data) {
            if (!Modernizr.localstorage)
                return;

            var message = JSON.stringify({
                name: name,
                data: data,

                // We need to append a cache buster to the storage key so that
                // `storage` events are correctly triggered in other frames =/
                time: new Date().getTime(),
            });

            try {
                window.localStorage.setItem(this.constructor.STORAGE_KEY, message);
            } catch (error) {
                // TODO: log error w/ Raven.js
            }

        },

        onStorageEvent: function (evt) {
            var key = evt.originalEvent.key;
            var message = evt.originalEvent.newValue;

            if (!(message && key === this.constructor.STORAGE_KEY))
                return;

            try {
                message = JSON.parse(message);
                this.trigger(message.name, message.data);
            } catch (error) {
                // TODO: log error w/ Raven.js
            }
        },
    }, {
        STORAGE_KEY: 'disqus.bus',
    });

    return WindowBus;
});

